import React from "react";
import "./style/basketTableStyle.scss";
import "../../../style/block.scss";
import "../../../style/feature.scss";
import "../../../style/hovers.scss";
import "./style/style.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  total: number;
}

const BasketSummary: React.FC<IProps> = ({ total }: IProps) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="basket-summary">
        <h3>{t("podsumowanie_zamowienia")}</h3>

        <div className="summary-line flex-between-center">
          <span>{t("do_zaplaty")}:</span>
          <b>
            {total} {t("zl")}
          </b>
        </div>
        <div className="main-line flex-between-center">
          <span>{t("lacznie")}:</span>
          <b>
            {total} {t("zl")}
          </b>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasketSummary;
